import { List } from './list'

const talents = [
  { label: 'Post Roles' },
  { label: 'Launch internal job board' },
  { label: 'Enable referrals ' },
  { label: 'Track ROI' },
  { label: 'Fill faster' },
]
const refferals = [
  { label: 'Get access' },
  { label: 'Browse internal roles' },
  { label: 'Refer in seconds' },
  { label: 'Track status' },
  { label: 'Get rewarded' },
]
const recruiters = [
  { label: 'AI match smarter' },
  { label: 'Collaborate via CoreShare' },
  { label: 'Share or loan candidates' },
  { label: 'Place more talent' },
]

export const HowItWork = () => {
  return (
    <div className="relative max-w-7xl mx-auto px-6">
      <img className="absolute -top-36 left-1/2 -translate-x-1/2 h-[600px]" src="/circle2.png" alt="" />
      <p className='font-oxanium font-medium text-5xl mb-12 text-center text-white relative z-20'>How it works</p>
      <div className='relative z-20 p-10 rounded-[32px] bg-gradient-to-b from-[rgba(255,255,255,0.1)] to-[rgba(255,255,255,0)] border border-[rgba(255,255,255,0.1)]'>
        <div className='flex flex-col md:flex-row justify-between space-y-8 md:space-y-0 md:space-x-4'>
          <div>
            <p className='font-oxanium font-medium text-2xl text-white mb-12'>For Talent Teams</p>
            <List steps={talents} />
          </div>
          <div className="md:hidden bg-[linear-gradient(90deg,rgba(75,186,206,0)_0%,rgba(75,186,206,.2)_50%,rgba(75,186,206,0)_100%)] h-[2px]"></div>
          <div className='hidden md:block bg-[linear-gradient(180deg,rgba(75,186,206,0)_0%,rgba(75,186,206,.2)_50%,rgba(75,186,206,0)_100%)] w-[2px]'></div>
          <div>
            <p className='font-oxanium font-medium text-2xl text-white mb-12'>For Referrers</p>
            <List steps={refferals} />
          </div>
          <div className="md:hidden bg-[linear-gradient(90deg,rgba(75,186,206,0)_0%,rgba(75,186,206,.2)_50%,rgba(75,186,206,0)_100%)] h-[2px]"></div>
          <div className='hidden md:block bg-[linear-gradient(180deg,rgba(75,186,206,0)_0%,rgba(75,186,206,.2)_50%,rgba(75,186,206,0)_100%)] w-[2px]'></div>
          <div>
            <p className='font-oxanium font-medium text-2xl text-white mb-12'>For Recruiters</p>
            <List steps={recruiters} />
          </div>
        </div>
      </div>
    </div>
  )
}

